import { PageLayout } from '~/components/PageLayout/PageLayout';
import { Link } from '~/components/Link/Link';
import { Fragment } from 'react/jsx-runtime';

export function Page() {
  return (
    <Fragment>
      <Fragment>
        <PageLayout.Heading text="Något gick fel!" />

        <p style={{ marginBottom: 'var(--size-4)' }}>
          Tyvärr verkar verifieringslänken inte längre vara giltig.
          <br />
          Du kan skicka en ny verifieringslänk genom att använda funktionen{' '}
          <Link to="/auth/reset-password/request" underline>
            Återställ lösenord
          </Link>
          .
        </p>
      </Fragment>
    </Fragment>
  );
}
